import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { MatSelectionListChange } from '@angular/material/list';
import { ImageItem } from './model/item-image.interface';
import { deepCopyFunction } from 'src/app/data/utils/object.utils';
@Component({
  selector: 'app-select-simple-list',
  templateUrl: './select-simple-list.component.html',
  styleUrls: ['./select-simple-list.component.scss'],
})
export class SelectSimpleListComponent implements OnInit {
  @Input() searchPlaceHolder: string | undefined;
  @Input() selectAllText: string | undefined;
  @Input() list: ImageItem[] = [];
  @Input() hideSearchComponent: boolean | undefined;
  @Input() hidePhoto: boolean | undefined;
  @Input() hideButtons = false;

  @Output() selectEvent = new EventEmitter<ImageItem[]>();

  workingList: ImageItem[] = [];
  initialList: ImageItem[] = [];
  allSelected = false;
  filteredList: ImageItem[] = [];
  hasItemChecked = false;
  hasItemChanged = false;

  constructor() {}

  ngOnInit(): void {
    this.workingList = deepCopyFunction(this.list);
    if (!this.searchPlaceHolder) {
      this.searchPlaceHolder = 'Pesquise por aqui ...';
    }
    if (!this.selectAllText) {
      this.selectAllText = 'Marcar/Desmarcar todos os itens';
    }
    this.initialList = this.workingList;
    if (this.workingList.length > 0) {
      this.allSelected =
        this.workingList.filter((item) => item.isChecked).length === this.workingList.length;
    }
    this.hasItemChecked = this.workingList.some((item)=>item.isChecked);
  }

  handleEvent(evt: MatSelectionListChange) {
    evt.options
      .map((o) => o.value)
      .forEach((node) => {
        if (typeof node === 'boolean') {
          this.allSelected = !this.allSelected;
          this.selectDeselectAll();
        } else {
          const item = this.workingList.find(
            (item) => item.id == node.id
          ) as ImageItem;
          item.isChecked = evt.options[0].selected;
          this.allSelected = this.isAllSelected();
        }
      });
    if (this.hideButtons) {
      this.emitEvent();
    }
    this.hasItemChecked = this.workingList.some((item)=>item.isChecked);
    this.hasItemChanged =
      JSON.stringify(this.workingList) != JSON.stringify(this.list);
  }
  private isAllSelected(): boolean {
    return this.workingList.every((item) => item.isChecked);
  }

  private emitEvent() {
    if (this.filteredList.length > 0) {
      this.selectEvent.emit(
        this.initialList.map(
          (obj) => this.filteredList.find((o) => o.id === obj.id) || obj
        )
      );
    } else {
      this.selectEvent.emit(this.workingList);
    }
  }

  selectDeselectAll(): void {
    this.workingList.forEach((item) => {
      item.isChecked = this.allSelected;
    });
    this.hasItemChecked = this.workingList.some((item)=>item.isChecked);
    this.hasItemChanged =
      JSON.stringify(this.workingList) != JSON.stringify(this.list);
    if (this.hideButtons) {
      this.emitEvent();
    }
  }

  filter(value: any) {
    this.filteredList = [];
    if (value == undefined || value == '') {
      this.workingList = this.initialList;
    } else {
      this.workingList.forEach((item) => {
        if (item.name.toLocaleLowerCase().includes(value.toLocaleLowerCase())) {
          this.filteredList.push(item);
        }
      });
      this.workingList = [...new Set(this.filteredList)];
    }
  }

  resetSelection() {
    this.allSelected = false;
    this.selectDeselectAll();
    this.hasItemChecked = false;
    this.hasItemChanged =
      JSON.stringify(this.workingList) != JSON.stringify(this.list);
  }

  applySelection() {
    this.emitEvent();
  }

  isPartiallySelected(): boolean {
    let result =
      this.workingList.some((item) => item.isChecked) && !this.isAllSelected();
    return result;
  }

  selectAllClicked() {
    this.allSelected = !this.allSelected;
    this.selectDeselectAll();
  }
}
